"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _shader = _interopRequireDefault(require("./shader"));

var cyanBase = '#3699B6';
var cyan = {
  dark40: (0, _shader["default"])(-0.4, cyanBase),
  //#071519
  dark30: (0, _shader["default"])(-0.3, cyanBase),
  //#133640
  dark20: (0, _shader["default"])(-0.2, cyanBase),
  //#1F5767
  dark10: (0, _shader["default"])(-0.1, cyanBase),
  //#2A788F
  base: cyanBase,
  light10: (0, _shader["default"])(0.1, cyanBase),
  //#53B1CC
  light20: (0, _shader["default"])(0.2, cyanBase),
  //#7AC3D8
  light30: (0, _shader["default"])(0.3, cyanBase),
  //#A2D4E3
  light40: (0, _shader["default"])(0.4, cyanBase),
  //#C9E6EF
  light45: (0, _shader["default"])(0.45, cyanBase) //#DDEFF5

};
var _default = cyan;
exports["default"] = _default;